import { createElement } from 'react';
import { useRouter } from '../hooks/useRouter';
import { Redirect } from 'react-router';

export function withProtection<T extends {}>(
	Component: React.FC<T>,
	options: { access: (props: T) => boolean; redirectTo: string }
) {
	return (props: T) => {
		const router = useRouter();

		return options.access(props)
			? createElement(Component, props)
			: createElement(Redirect, { to: `${router.basePath}${options.redirectTo}` });
	};
}
